export default __webpack_public_path__ + "static/cruiselines-vrc-ship-6-b968b37aafb0d52ff726ca8cdb7e4e0e.jpg";